import moment from "moment";

const WEEKDAYS = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
const ORDINALS = ["First", "Second", "Third", "Fourth", "Fifth"];

export function getWeekOfMonth(date: Date): number {
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  return Math.ceil((date.getDate() + firstDay.getDay()) / 7);
}

export function getOrdinal(n: number): string {
  return ORDINALS[n - 1] ?? `${n}th`;
}

export function getDaySuffix(n: number): string {
  if (n >= 11 && n <= 13) return "th";
  return ["th", "st", "nd", "rd"][Math.min(n % 10, 4)] || "th";
}

export function roundUpTime(date: Date, interval: number): Date {
  const m = moment(date);

  const minutes = m.minutes();
  const remainder = minutes % interval;

  let roundedMinutes: number;

  if (remainder < interval / 2) {
    // Round down
    roundedMinutes = minutes - remainder;
  } else {
    // Round up
    roundedMinutes = minutes + (interval - remainder);
  }

  return m
    .minutes(roundedMinutes)
    .seconds(0)
    .milliseconds(0)
    .toDate();
};

export function floorToInterval(date: Date, interval: number): Date {
  const m = moment(date);

  const minutes = m.minutes();
  const flooredMinutes = Math.floor(minutes / interval) * interval;

  return m
    .minutes(flooredMinutes)
    .seconds(0)
    .milliseconds(0)
    .toDate();
}

export function ceilToInterval(date: Date, interval: number): Date {
  const m = moment(date);

  const remainder = m.minutes() % interval;

  if (remainder === 0) return m.seconds(0).toDate();

  const minutesToAdd = interval - remainder;

  return m
    .add(minutesToAdd, "minutes")
    .seconds(0)
    .toDate();
};